import { useEffect, useRef } from "react";
var useEventListener = function useEventListener(type, callback) {
  var elRef = useRef(null);
  useEffect(function () {
    if (elRef.current) {
      var element = elRef.current;
      element.addEventListener(type, function (e) {
        callback(e);
      });
      return function () {
        element.removeEventListener(type, callback);
      };
    }
  }, [elRef.current]);
  return elRef;
};
export default useEventListener;
//# sourceMappingURL=useEventListener.js.map